;$(function () {
  'use strict'

  var $addPost = $('[data-add-post]')
  var $addPostFixed = $('[data-add-post-fixed]')

  if (document.documentElement.clientWidth >= 768) {
    $(window).on('scroll', function () {
      if ($addPost.is(':in-viewport')) {
        $addPostFixed.addClass('layout__none')
      }
      else {
        $addPostFixed.removeClass('layout__none')
      }
    })
  }
  else {
    $addPostFixed.removeClass('layout__none')
  }
})
